module.exports = __webpack_public_path__ + "static/media/MetaMaskAccount.93a53bcd.png";